import { render, staticRenderFns } from "./volatile_quarter.vue?vue&type=template&id=2dda0473&"
import script from "./volatile_quarter.vue?vue&type=script&lang=js&"
export * from "./volatile_quarter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports